import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type AddRowBelowProps = IconComponentBaseProps;

export const AddRowBelow = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[8],
}: AddRowBelowProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_5468_53053"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5468_53053)">
        <path
          d="M12.6663 7.35234V3.37167C12.6663 3.31178 12.6471 3.26262 12.6087 3.22417C12.5702 3.18573 12.5211 3.1665 12.4612 3.1665H3.53817C3.47829 3.1665 3.42912 3.18573 3.39067 3.22417C3.35223 3.26262 3.33301 3.31178 3.33301 3.37167V7.35234H12.6663ZM3.53817 13.4998C3.20673 13.4998 2.92301 13.3818 2.68701 13.1458C2.45101 12.9098 2.33301 12.6261 2.33301 12.2947V3.37167C2.33301 3.04023 2.45101 2.7565 2.68701 2.5205C2.92301 2.2845 3.20673 2.1665 3.53817 2.1665H12.4612C12.7926 2.1665 13.0763 2.2845 13.3123 2.5205C13.5483 2.7565 13.6663 3.04023 13.6663 3.37167V12.2947C13.6663 12.6261 13.5483 12.9098 13.3123 13.1458C13.0763 13.3818 12.7926 13.4998 12.4612 13.4998H11.7945C11.6528 13.4998 11.5341 13.4519 11.4383 13.356C11.3425 13.2601 11.2945 13.1413 11.2945 12.9997C11.2945 12.8579 11.3425 12.7392 11.4383 12.6435C11.5341 12.5477 11.6528 12.4998 11.7945 12.4998H12.4612C12.5211 12.4998 12.5702 12.4806 12.6087 12.4422C12.6471 12.4037 12.6663 12.3546 12.6663 12.2947V8.35234H3.33301V12.2947C3.33301 12.3546 3.35223 12.4037 3.39067 12.4422C3.42912 12.4806 3.47829 12.4998 3.53817 12.4998H4.20484C4.34651 12.4998 4.46523 12.5478 4.56101 12.6437C4.6569 12.7396 4.70484 12.8583 4.70484 13C4.70484 13.1418 4.6569 13.2605 4.56101 13.3562C4.46523 13.4519 4.34651 13.4998 4.20484 13.4998H3.53817ZM7.99951 14.8332C7.85773 14.8332 7.73901 14.7852 7.64334 14.6893C7.54756 14.5936 7.49967 14.4748 7.49967 14.3332V13.4998H6.66634C6.52467 13.4998 6.40595 13.4519 6.31017 13.356C6.21429 13.2601 6.16634 13.1413 6.16634 12.9997C6.16634 12.8579 6.21429 12.7392 6.31017 12.6435C6.40595 12.5477 6.52467 12.4998 6.66634 12.4998H7.49967V11.6665C7.49967 11.5248 7.54762 11.4061 7.64351 11.3102C7.7394 11.2144 7.85817 11.1665 7.99984 11.1665C8.14162 11.1665 8.26034 11.2144 8.35601 11.3102C8.45179 11.4061 8.49967 11.5248 8.49967 11.6665V12.4998H9.33301C9.47467 12.4998 9.5934 12.5478 9.68917 12.6437C9.78506 12.7396 9.83301 12.8583 9.83301 13C9.83301 13.1418 9.78506 13.2605 9.68917 13.3562C9.5934 13.4519 9.47467 13.4998 9.33301 13.4998H8.49967V14.3332C8.49967 14.4748 8.45173 14.5936 8.35584 14.6893C8.25995 14.7852 8.14117 14.8332 7.99951 14.8332Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
